module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "lpn_iv"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("This digital edition first published by Canongate in 2011")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("I")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Copyright © Olivia Laing, 2011")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("The moral right of the author has been asserted")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("First published in Great Britain in 2011 by Canongate Books Ltd,"), _c('br'), _vm._v("\n  14 High Street, Edinburgh EH1 1TE")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_c('a', {
    attrs: {
      "href": "http://www.canongate.tv",
      "target": "_blank"
    }
  }, [_vm._v("www.canongate.tv")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("For permission acknowledgements, please see "), _c('span', {
    attrs: {
      "href": "#/html/028_permission#acknow2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_c('i', [_vm._v("British Library Cataloguing-in-Publication Data")]), _c('br'), _vm._v("\n  A catalogue record for this book is available on request from the British Library")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("ISBN 978 1 84767 792 1"), _c('br'), _vm._v("\n  eISBN 978 0 85786 065 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Typeset by Palimpsest Book Production Ltd, Falkirk, Stirlingshire")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Map of the Ouse copyright © Helen Macdonald, 2011")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c372fcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/003_cr.vue
// module id = 66
// module chunks = 0